import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface GalleryHeroProps {
  title: string;
  subtitle: string;
  description: string;
}

const GalleryHero = ({ title, subtitle, description }: GalleryHeroProps) => {
  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-secondary/5 py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <div className="flex justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-primary/20 blur-2xl rounded-full"></div>
              <Icon 
                name="PhotoIcon" 
                size={64} 
                className="text-primary relative z-10"
              />
            </div>
          </div>
          
          <h1 className="font-playfair text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground mb-4">
            {title}
          </h1>
          
          <p className="font-playfair text-xl sm:text-2xl text-primary italic mb-6">
            {subtitle}
          </p>
          
          <p className="font-inter text-base sm:text-lg text-muted-foreground leading-relaxed">
            {description}
          </p>
        </div>
      </div>
    </section>
  );
};

export default GalleryHero;